module.exports = __webpack_public_path__ + "img/sites.31b179b1.svg";